/**
 * Route: /admin/system — infrastructure status (OpenSearch, dramatiq, MaxMind).
 *
 * Admin-only. Each card renders its endpoint data or an EmptyState when none is available.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

import { me } from '../../lib/auth';
import { toast } from '../../lib/toast';
import { SystemAdmin } from '../../features/admin/SystemAdmin';

export const Route = createFileRoute('/admin/system')({
  beforeLoad: async () => {
    try {
      const profile = await me();
      if (profile.platform_role !== 'admin') {
        toast({
          tone: 'error',
          message: 'Alleen admins hebben toegang tot deze pagina.',
        });
        throw redirect({ to: '/' });
      }
    } catch (err) {
      if (err && typeof err === 'object' && 'to' in err) {
        throw err;
      }
      throw redirect({ to: '/login' });
    }
  },
  component: SystemAdmin,
});
